import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';
import { idEventLogsAnalytics } from './types/identityEventLogsAnalytics';
import { UserCapabilityName } from '../../types/userCapabilityName';

const IdentityEventLogs = lazy(
  () =>
    import(/* webpackChunkName: "identity-event-logs" */ './IdentityEventLogs')
);

const { identityEventLogs } = idEventLogsAnalytics;

export const identityEventLogsRoutes = (
  <Route
    path="event-logs"
    element={
      <PageRoute
        pageInfo={identityEventLogs}
        userCapabilities={[
          UserCapabilityName.SuperAdmin,
          UserCapabilityName.ViewEventLogs,
        ]}
      >
        <IdentityEventLogs />
      </PageRoute>
    }
  />
);
